"use client";

import { useMemo } from "react";

import { SymbolInfo } from "@/features/analysis/services/symbol-info";
import { useLang } from "@/hooks/use-lang";

import { TradingViewAdvancedChart } from "./TradingViewAdvancedChart";

type Props = {
  symbol: string;
  symbolInfo: SymbolInfo;
};

export const TradingViewAdvancedComponent = ({ symbol, symbolInfo }: Props) => {
  const { t, lang } = useLang();

  const tradingViewSymbol = useMemo(() => {
    const symbolWithExchange = symbolInfo.exchange
      ? `${symbolInfo.exchange}:${symbol}`
      : symbol;
    const finalSymbol = symbolWithExchange.replaceAll("-", "/");
    return finalSymbol;
  }, [symbolInfo.exchange, symbol]);

  return (
    <>
      <h2>{t.analysis.overview.price(symbol)}</h2>
      <div className="h-[350px] w-full py-5 sm:h-[500px]">
        <TradingViewAdvancedChart lang={lang} symbol={tradingViewSymbol} />
      </div>
    </>
  );
};
